import { AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractEncoder.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString3o7ifthqydp6e as toString,
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { CLASS_getInstance14ex35co4jkrb as CLASS_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { replace3le3ie7l9k8aq as replace } from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataOutputEncoderClass;
function DataOutputEncoder() {
  if (DataOutputEncoderClass === VOID) {
    class $ extends AbstractEncoder() {
      static y4b($outer, output, $box) {
        if ($box === VOID)
          $box = {};
        $box.x4b_1 = $outer;
        var $this = this.d14($box);
        $this.v4b_1 = output;
        $this.w4b_1 = -1;
        return $this;
      }
      mz() {
        return this.x4b_1.z4b_1;
      }
      h14(value) {
        this.v4b_1(value.toString());
      }
      i14(value) {
        this.v4b_1(value.toString());
      }
      j14(value) {
        this.v4b_1(value.toString());
      }
      k14(value) {
        this.v4b_1(value.toString());
      }
      l14(value) {
        this.v4b_1(value.toString());
      }
      m14(value) {
        this.v4b_1(value.toString());
      }
      n14(value) {
        this.v4b_1(value.toString());
      }
      o14(value) {
        this.v4b_1(toString(value));
      }
      p14(value) {
        this.v4b_1(value);
      }
      q14(enumDescriptor, index) {
        this.v4b_1(enumDescriptor.v11(index));
      }
      g15(descriptor, collectionSize) {
        this.k14(collectionSize);
        return DataOutputEncoder().y4b(this.x4b_1, this.v4b_1);
      }
      l13(descriptor) {
        return DataOutputEncoder().y4b(this.x4b_1, this.v4b_1);
      }
      g14() {
        return this.h14(false);
      }
      f15() {
        return this.h14(true);
      }
      e14(descriptor, index) {
        if (equals(descriptor.s11(), CLASS_getInstance())) {
          if (index === (this.w4b_1 + 1 | 0) && !descriptor.z11(index)) {
            this.w4b_1 = index;
          } else {
            this.v4b_1(descriptor.v11(index));
            this.w4b_1 = index;
          }
        }
        return true;
      }
      m13(descriptor) {
        if (equals(descriptor.s11(), CLASS_getInstance()) && !(this.w4b_1 === (descriptor.u11() - 1 | 0))) {
          if (descriptor.u11() >= 254) {
            this.v4b_1('end');
          }
        }
      }
    }
    initMetadataForClass($, 'DataOutputEncoder');
    DataOutputEncoderClass = $;
  }
  return DataOutputEncoderClass;
}
var StringArrayFormatClass;
function StringArrayFormat() {
  if (StringArrayFormatClass === VOID) {
    class $ {
      constructor(serializersModule) {
        this.z4b_1 = serializersModule;
      }
      mz() {
        return this.z4b_1;
      }
      x27(serializer, value) {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().d1();
        var $this$buildString = this_0;
        var first = {_v: true};
        DataOutputEncoder().y4b(this, (it) => {
          if (first._v) {
            first._v = false;
          } else
            $this$buildString.xb(_Char___init__impl__6a9atx(44));
          $this$buildString.wb(replace(replace(it, '\\', '\\\\'), ',', '\\,'));
          return Unit_instance;
        }).nz(serializer, value);
        return this_0.toString();
      }
    }
    initMetadataForClass($, 'StringArrayFormat');
    StringArrayFormatClass = $;
  }
  return StringArrayFormatClass;
}
//region block: exports
export {
  StringArrayFormat as StringArrayFormat41o1nrt6c6ex,
};
//endregion

//# sourceMappingURL=StringArrayFormat.mjs.map
